import React, { useState, useEffect } from 'react';
import NewsList from './components/NewsList';
import './App.css';
import { LoadingState, EmptyState } from './components/LoadingStates';
// import TopRightButtons from './components/TopRightButtons';
import TrendingPopup from './components/TrendingPopup';
import DisclaimerPopup from './components/DisclaimerPopup';
import URLAnalyzerPopup from './components/URLAnalyzerPopup';
import Header from './components/Header'; // Import the new Header component

function App() {
  const [news, setNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(null);
  const [loadingTrending, setLoadingTrending] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isDisclaimerPopupOpen, setIsDisclaimerPopupOpen] = useState(false);
  const [isTrendingOpen, setIsTrendingOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  // const [darkMode, setDarkMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    //   // Check for dark mode preference in localStorage
    //   const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    //   setDarkMode(savedDarkMode);

    //   // Apply dark mode class if needed
    //   if (savedDarkMode) {
    //     document.body.classList.add('dark-mode');
    //   }

    fetchData();
  }, []);

  useEffect(() => {
    // Filter news based on search term
    if (news.length > 0) {
      if (searchTerm.trim() === '') {
        setFilteredNews(news);
      } else {
        const term = searchTerm.toLowerCase();
        const filtered = news.filter(item =>
          item.title.toLowerCase().includes(term) ||
          (item.description && item.description.toLowerCase().includes(term))
        );
        setFilteredNews(filtered);
      }
    }
  }, [searchTerm, news]);

  async function fetchData() {
    try {
      setLoading(true);
      // const newsResponse = await fetch('http://localhost:5000/api/rss/feeds');
      const newsResponse = await fetch('/.netlify/functions/feeds');
      const newsData = await newsResponse.json();
      setNews(newsData);
      setFilteredNews(newsData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  async function fetchTrendingData(newsDetails) {
    try {
      setIsTrendingOpen(true)
      setLoadingTrending(true)
      // const trendingResponse = await fetch('http://localhost:5000/api/rss/trending', {
      const trendingResponse = await fetch('/.netlify/functions/trending', {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ newsDetails }),
      });

      const trendingData = await trendingResponse.json();
      setLoadingTrending(false);

      if (Array.isArray(trendingData)) {
        setTrending(trendingData);
      } else {
        console.error('Data trending bukan array:', trendingData);
        setTrending([]);
      }
    } catch (error) {
      console.error('Error fetching trending data:', error);
      setLoadingTrending(false);
    }
  }

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  // const toggleDarkMode = () => {
  //   const newDarkMode = !darkMode;
  //   setDarkMode(newDarkMode);
  //   document.body.classList.toggle('dark-mode', newDarkMode);
  //   localStorage.setItem('darkMode', newDarkMode);
  // };

  const formattedTime = currentTime.toLocaleTimeString('id-ID', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).replace(/\./g, ':');

  const formattedDate = currentTime.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="App">
      <Header
        onSearch={handleSearch}
        setIsDisclaimerPopupOpen={setIsDisclaimerPopupOpen}
        fetchTrendingData={fetchTrendingData}
        news={news}
        setIsPopupOpen={setIsPopupOpen}
        setCurrentTime={setCurrentTime}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      {/* <TopRightButtons
        setIsDisclaimerPopupOpen={setIsDisclaimerPopupOpen}
        fetchTrendingData={fetchTrendingData}
        news={news}
        setIsPopupOpen={setIsPopupOpen}
        setCurrentTime={setCurrentTime}
      /> */}

      <main className="content">
        {loading ? (
          <LoadingState />
        ) : filteredNews.length === 0 ? (
          <EmptyState searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        ) : (
          <NewsList newsItems={filteredNews} currentTime={currentTime} />
        )}
      </main>

      <URLAnalyzerPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        formattedDate={formattedDate}
        formattedTime={formattedTime}
      />

      <DisclaimerPopup
        isOpenDisclaimer={isDisclaimerPopupOpen}
        onCloseDisclaimer={() => setIsDisclaimerPopupOpen(false)}
        news={news}
      />

      <TrendingPopup
        isOpen={isTrendingOpen}
        onCloseTrending={() => setIsTrendingOpen(false)}
        formattedDate={formattedDate}
        formattedTime={formattedTime}
        news={news}
        trending={trending}
        loadingTrending={loadingTrending}
      />
    </div>
  );
}

export default App;